import {Utilities} from '@shared/utilities/utilities.model';

export class CarbodyWorkingItemsModel {
    bodyRepair: boolean;
    findFromTheft: boolean;
    lostKey: boolean;
    partialTheft: boolean;
    floodedCar: boolean;
    burnedCar: boolean;
    restoreMissingParts: boolean;
    corrosionPaintedParts: boolean;
    deterioratedExternalParts: boolean;
    bumpUndercover: boolean;
    glassReplacement: boolean;
    glassRepair: boolean;

    constructor(model?: any) {
        if (!Utilities.isVoid(model)) {
            this.bodyRepair = model.body_repair;
            this.findFromTheft = model.find_from_theft;
            this.lostKey = model.lost_key;
            this.partialTheft = model.partial_theft;
            this.floodedCar = model.flooded_car;
            this.burnedCar = model.burned_car;
            this.restoreMissingParts = model.restore_missing_parts;
            this.corrosionPaintedParts = model.corrosion_painted_parts;
            this.deterioratedExternalParts = model.deteriorated_external_parts;
            this.bumpUndercover = model.bump_undercover;
            this.glassReplacement = model.glass_replacement;
            this.glassRepair = model.glass_repair;
        }
    }
}

export class CarbodyWorkingItemsRequestModel {
    body_repair: boolean;
    find_from_theft: boolean;
    lost_key: boolean;
    partial_theft: boolean;
    flooded_car: boolean;
    burned_car: boolean;
    restore_missing_parts: boolean;
    corrosion_painted_parts: boolean;
    deteriorated_external_parts: boolean;
    bump_undercover: boolean;
    glass_replacement: boolean;
    glass_repair: boolean;

    constructor(model?: any) {
        if (!Utilities.isVoid(model)) {
            this.body_repair = model.bodyRepair;
            this.find_from_theft = model.findFromTheft;
            this.lost_key = model.lostKey;
            this.partial_theft = model.partialTheft;
            this.flooded_car = model.floodedCar;
            this.burned_car = model.burnedCar;
            this.restore_missing_parts = model.restoreMissingParts;
            this.corrosion_painted_parts = model.corrosionPaintedParts;
            this.deteriorated_external_parts = model.deterioratedExternalParts;
            this.bump_undercover = model.bumpUndercover;
            this.glass_replacement = model.glassReplacement;
            this.glass_repair = model.glassRepair;
        }
    }
}
